import Utils from ".";

class Auth {
    static tokenKey = "_t";
    static proxyTokenKey = "_proxy";
    /**
     * Authenticate a user. Save a token string in Session Storage
     *
     * @param {string} token
     */
    static setToken(token) {
        localStorage.setItem(this.tokenKey, token)
    }
    /**
     * Get a token value.
     *
     * @returns {string}
     */
    static getToken() {
        return localStorage.getItem(this.tokenKey)
    }
    static getProxyToken(proxyToken) {
        return localStorage.getItem(this.proxyTokenKey, proxyToken)
    }
    /**
     * Deauthenticate a user. Remove a token from Session Storage.
     *
     */
     static removeToken() {
         localStorage.removeItem(this.tokenKey) 
    }
    /**
     * Check if a user is authenticated - check if a token is saved in Session Storage
     *
     * @returns {boolean}
     */
    static isUserAuthenticated() {
        return localStorage.getItem(this.tokenKey) !== null
    }    
    /**
     * Get auth toke from token
     */
    static getAuthToken() {
        return Utils.extractValFromToken("auth_token");
    }   
    static isPathValid(pathsToValidate = [] ) {
        const accessMenusString = localStorage.getItem("accessMenus") ||'{"path":[],"menus":[]}';
        const accessMenus = JSON.parse(accessMenusString);
        
        if (!accessMenus?.path || !Array.isArray(accessMenus?.path)) {
            accessMenus.path = [];
            // localStorage.clear(); 
            // window.location.href = "/";
        }

        return pathsToValidate.some(path => accessMenus.path.includes(path));
     }

}

export default Auth;